import { render, staticRenderFns } from "./TicketDomainConfig.vue?vue&type=template&id=43b5db49"
import script from "./TicketDomainConfig.vue?vue&type=script&lang=js"
export * from "./TicketDomainConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports